import React, { FC, useEffect } from 'react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { UserHeader } from '../../../../shared/layout/header/UserHeader';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { PASSENGERS_PARKING_LANDING_PAGE_ID } from '../../../../shared/api/contentful/constants';
import { useNewBookingStore } from '../../../domain/booking/stores/useNewBookingsStore';
import { ConfirmationModifiedBooking } from '../../booking-steps/confirmation/ConfirmationModifiedBooking';
import { useNavigate } from '../../../../shared/router/useNavigate';
import { ConfirmationMain } from '../../booking-steps/confirmation/ConfirmationMain';

export const FullAmendConfirmationPage: FC = () => {
	const { t } = useTranslation();
	const landingPageUrl = useUrlForPageId(PASSENGERS_PARKING_LANDING_PAGE_ID);
	const { booking, originalBooking } = useNewBookingStore();
	const navigate = useNavigate();

	useEffect(() => {
		if (!originalBooking) {
			navigate(landingPageUrl);
		}
	}, [originalBooking]);

	return (
		<>
			<title>Charlotte Airport - Booking Confirmed</title>
			<UserHeader
				theme="green-blue"
				title={t('web_parking_modify_confirmation_header')}
			/>
			<ConfirmationMain>
				{originalBooking && (
					<ConfirmationModifiedBooking
						booking={booking}
						originalBooking={originalBooking}
					/>
				)}
			</ConfirmationMain>
		</>
	);
};
